import angular from 'angular';
import { TipoBeneficios, TipoBeneficiosEnum } from '../../beneficios.enum';
import { TrabalhadoresService } from '../../../../trabalhadores.service';
import { PlanosModalService } from '../../modal/planos/planos.modal.service';
import { IReativacaoBeneficioGet } from '../../model/reativacao.model';

export class MeurhBeneficiosReativacaoFormController {

    static $inject = [
        '$scope',
        '$rootScope',
        'PlanosModalService',
        'TrabalhadoresService'
    ];

    public tipoBeneficio: TipoBeneficiosEnum;
    public limitDate: Date | string;
    public limitEndDate: Date | string;
    public entity: IReativacaoBeneficioGet;
    public form: angular.IFormController;
    public editable = false;

    public tiposDeBeneficiosConst = TipoBeneficios;
    public nomeBeneficiario: string;
    public busy = false;

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & { session: any },
        public PlanosModalService: PlanosModalService,
        public TrabalhadoresService: TrabalhadoresService
    ) {}

    $onInit() {
        if (!this.editable) {
            this.setBeneficiario();
        }
    }

    setBeneficiario() {
        if (!this.entity.dependentetrabalhador?.dependentetrabalhador) {
            this.nomeBeneficiario = this.entity.trabalhador.nome + ' (Titular)';
            return;
        }
        this.nomeBeneficiario = this.entity.dependentetrabalhador.nome + ' (Dependente)';
    }

    openPlanosModal() {
        const modal = this.PlanosModalService.open({
            beneficio: this.entity.beneficio,
            tipoBeneficio: this.tipoBeneficio,
            editable: this.editable
        });
        modal.result.then((response) => {
            this.entity.beneficio = response;
        }).catch(() => {/**/});
    }

}
